module.exports = __webpack_public_path__ + "img/material.53ebffed.png";